import { render, staticRenderFns } from "./IZoom.vue?vue&type=template&id=6dc11fc0&"
import script from "./IZoom.vue?vue&type=script&lang=ts&"
export * from "./IZoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports